<!--*
 * Component to show place information
 *
 * @author   mauricio.figueroa
 * @date     2020-07-06
 *
 * @copyright 2020 Smartmatic Corp. All Rights Reserved.
 *
 * @license
 *
 * Confidential information of Smartmatic Labs. Not for disclosure or
 * distribution prior written consent. This software contains code, techniques
 * and know-how which is confidential and proprietary to Smartmatic.
 *
 * Use of this software is subject to the terms of an end user license
 * agreement.
-->
<template>
  <div>
    <div class="mb-1">
      {{ `${progress} ${$t('surveyStatus.progressbar.stat1')} ${total} ${$t('surveyStatus.progressbar.stat2')}`}}
    </div>
    <div
      id="progress-container"
      class="progress"
    >
      <div
        class="progress-bar"
        role="progressbar"
        :style="`width: ${currentProgress}%`"
      />
    </div>
  </div>
</template>
<script>
export default {
  'name': 'SurveyStatusProgressbar',
  'props': [ 'total', 'progress' ],
  'computed': {
    'currentProgress': function () {
      if (this.total > 0) {
        return (this.progress / this.total) * 100;
      }
    }
  }
}
</script>

<style scoped>
  #progress-container {
    height: 8px;
  }
  .progress-bar {
    background-color: #663dd4;
  }
</style>
